<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <p class="headText1">
                        <i class="fas fa-user-check"> รายการจากออดิต </i>
                    </p>
                        <form #frm_syear="ngForm" class="form-inline">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">++เลือกปี++</span>
                                    </div>
                                    <select #syearid="ngModel" ngModel name="syearid" class="form-control" id="syearid" 
                                      (change)="getAuditData(frm_syear.value);">
                                      <option *ngFor="let item of yearID" 
                                          [value]="item.yearCr">{{ item.yearlb }}
                                      </option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    <div class="card-tools">
                      <button type="button" class="btn btn-tool"
                        (click)="getAuditData(frm_syear.value)" title="รีเฟรซข้อมูล"><i class="fas fa-sync-alt"></i></button>
                      <button type="button" class="btn btn-tool" data-card-widget="maximize">
                          <i class="fas fa-expand"></i></button>
                      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
                    </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-2" style="height: 500px">
                    <table #tb_data class="table table-hover table-head-fixed text-nowrap">
                        <thead>
                            <tr class="headText">
                                <th>วันที่แจ้ง</th>
                                <th>วันที่แจ้ง</th>
                                <th>กำหนดแล้วเสร็จ</th>
                                <th>ข้อมูลแปลง</th>
                                <th>ความเห็นออดิต</th>
                                <th>ความเห็น ผจก.โซน</th>
                                <th>สถานะ</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of auditdata">
                                <td>
                                  <img src="{{ item.Filepic }}" 
                                  (click)="modalShowPic(item.DataId)" data-bs-toggle="modal" data-bs-target="#md_showpic"
                                  class="img-thumbnail" alt="auditPic" style="height: 50px;width: 70px;">
                                </td>
                                <td class="align-middle">{{ item.Daterec | adtob }}</td>
                                <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td>
                                <td class="align-middle">
                                    {{ item.intlandno }} {{ item.fmname }} {{ item.canetype }}
                                    {{ item.landvalue }} ไร่ รูท {{ item.route }}
                                </td>
                                <td class="align-middle">{{ item.Comment }}</td>
                                <td class="align-middle">{{ item.Comment_2 }} <small class="text-red">
                                    <i class="fas fa-user-plus"> ({{ item.date_2 | adtob }}) </i> </small></td>
                                <td [ngClass]="{ 'text-success align-middle' : 'item.status_sv==5' }"                                    >
                                    {{ item.status_sv_doc }}</td>
                                <td class="text-center align-middle">
                                    <a *ngIf="item.status_sv!=5" (click)="modalUpdataaudit(item.DataId)" data-bs-toggle="modal"
                                        data-bs-target="#explan_plant">
                                        <i class="fas fa-edit"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- /.card-body -->
            </div>
        <!-- Modal บันทึกความเห็น ผจก -->
        <div class="modal fade" id="explan_plant" tabindex="-1" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" *ngFor="let item of cpbyone">
              <form #frm_upaudit="ngForm" class="form-inline">
                <div class="modal-header">
                  <blockquote class="blockquote">
                    <p>แปลง {{ item.intlandno }} {{ item.canetype }} {{ item.landvalue }} ไร่ รูท {{ item.route }} </p>
                    <footer class="blockquote-footer text-primary headText1">{{ item.fmname }}</footer>
                    <div class="direct-chat-msg">
                        <!-- <div class="direct-chat-infos clearfix">
                          <span class="direct-chat-name float-left">Alexander Pierce</span>
                          <span class="direct-chat-timestamp float-right">23 Jan 2:00 pm</span>
                        </div> -->
                        <img class="direct-chat-img" 
                            src="https://storage.googleapis.com/brr-farmluck.appspot.com/supcodePic/{{item.Auditor}}.png" alt="auditor">
                        <div class="direct-chat-text">
                            {{ item.Comment }}
                        </div>
                      </div>
                      <!-- <p>{{ item.DataId }}</p> -->
                  </blockquote>
                  <input #dataid="ngModel" ngModel name="dataid" [(ngModel)]="item.DataId" class="form-control"
                    type="hidden">
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text"> <i class="fas fa-user-edit"> บันทึกผู้จัดการโซน </i></span>
                        </div>
                        <input #Comment_2="ngModel" ngModel name="Comment_2" type="text" class="form-control" 
                          required
                          [ngClass]="{'is-invalid' : Comment_2.invalid && (Comment_2.dirty || Comment_2.touched)}"
                          [(ngModel)]="item.Comment_2">
                        <div class="invalid-feedback">
                          <span *ngIf="Comment_2.hasError('required')">*ต้องกรอกความเห็นของผจก.โซน</span>
                        </div>
                      </div>
                      <div class="input-group mb-3">
                        <label for="filepic_source">อัพโหลดภาพ(ถ้ามี)</label>
                        <input #filepic_source="ngModel" ngModel name="filepic_source" type="file"
                          class="form-control" (change)="selectFile($event)">
                        <button class="btn btn-warning" [disabled]="!selectedFiles" (click)="upload()">
                          <i class="	fas fa-cloud-upload-alt"> อัพโหลด</i>
                        </button>
                      </div>
                      <div *ngIf="currentFileUpload" class="progress mt-2 mb-2">
                        <div class="progress-bar progress-bar-info" role="progressbar"
                          attr.aria-valuenow="{{ percentage }}" aria-valuemin="0" aria-valuemax="100"
                          [ngStyle]="{ width: percentage + '%' }">
                          {{ percentage }}%
                        </div>
                      </div>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">imgUrl</span>
                        </div>
                        <input type="text" #Comment_2_imgurl="ngModel" ngModel name="Comment_2_imgurl" [(ngModel)]="urlImg"
                          class="form-control" readonly>
                      </div>
                    </div>
                    </div>
                  </div>
                <div class="modal-footer">
                  <button (click)="saveUpdateaudit(frm_upaudit.value);" type="submit" [disabled]="frm_upaudit.invalid"
                    class="btn btn-primary"><i class="fas fa-save"> บันทึก
                    </i></button>
                  <button type="button" class="btn btn-warning" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closemodel();"><i class="	fas fa-sign-out-alt"> ปิด </i></button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- / Modal บันทึกความเห็น ผจก -->

        <!-- The Modal filepic -->
        <div class="modal fade" id="md_showpic" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content" *ngFor="let item of cpbyone">
              <div class="modal-header">
                <blockquote class="blockquote">
                  <span> แปลง {{ item.intlandno }} {{ item.canetype }} {{ item.landvalue }} ไร่ รูท {{ item.route }} </span>
                  <footer class="blockquote-footer"><h1 class="headText1">{{ item.fmname }} </h1> </footer>
                </blockquote>
              </div>
              <div class="modal-body" >
                <div class="containerPic">
                  <img src="{{ item.Filepic }}" class="responsive">
                  <div class="top-left">
                    <div class="direct-chat-msg mt-2">
                      <div class="direct-chat-infos clearfix">
                        <!-- <span class="direct-chat-name float-left">Alexander Pierce</span> -->
                        <span class="direct-chat-timestamp float-right">{{ item.DateAudit | date }}</span>
                      </div>
                      <img class="direct-chat-img" 
                          src="https://storage.googleapis.com/brr-farmluck.appspot.com/supcodePic/{{item.Auditor}}.png" alt="auditor">
                      <div class="direct-chat-text">
                          {{ item.Comment }}
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="containerPic">
                  <img src="{{ item.Comment_2_imgurl }}" class="responsive">
                  <div class="top-left">
                    <div class="direct-chat-msg mt-2">
                      <div class="direct-chat-infos clearfix">
                        <!-- <span class="direct-chat-name float-left">Alexander Pierce</span> -->
                        <span class="direct-chat-timestamp float-right">{{ item.date_2 | date }}</span>
                      </div>
                      <img class="direct-chat-img" 
                          src="https://storage.googleapis.com/brr-farmluck.appspot.com/supcodePic/{{item.supcode}}.png" alt="auditor">
                      <div class="direct-chat-text">
                          {{ item.Comment_2 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
<app-footer></app-footer>